export type ResourceContextConfig = {
  fabricMipmapsHighQuality: boolean;
  fabricMipmapsUnsharp: boolean;
  frustumCulling: boolean;
};

/**
 * Create resources context config.
 */
export const create = (() => {
  const ConfigDef: ResourceContextConfig = {
    fabricMipmapsHighQuality: true,
    fabricMipmapsUnsharp: false,
    frustumCulling: true,
  };

  return (config?: Partial<ResourceContextConfig>) => {
    config ??= {};
    const all = { ...ConfigDef, ...config };
    return all;
  };
})();
